const initialState = () => ({
  channelsCustomers: [],
  webhookProviderWhatsapp: {},
  dataParameters: {},
});

const state = initialState();

export default state;
